export default {
  name: "IncidentCommentItem",
  props: {
    comment: { type: Object, required: true },
    parent_comment: { type: Object, default: null },
    report: { type: Object, required: true },
    controller: { type: Object, required: true },
    depth: { type: Number, default: 0 },
  },
  computed: {
    replies() {
      return Array.isArray(this.comment.reply_comment)
        ? this.comment.reply_comment
        : [];
    },
    replies_are_expanded() {
      return this.controller.are_incident_replies_expanded(
        this.report.id,
        this.comment.id,
      );
    },
  },
};
